<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right cq-config">
            <div v-if="!schoolId" class="cq-empty">
                <i class="el-icon-office-building"></i>
                <strong>请先选择学校</strong>
                <em>在左侧学校树点选后，即可编辑该校课堂质量点评规则</em>
            </div>

            <div v-else class="cq-panel" v-loading="loading">
                <header class="cq-head">
                    <div class="cq-head__copy">
                        <span class="cq-head__eyebrow">课堂质量点评</span>
                        <h2 class="cq-head__title">点评规则</h2>
                        <p class="cq-head__meta">
                            <span class="cq-school-chip">{{ schoolName || '未命名学校' }}</span>
                            <span>下课窗口、补评与老师提交规则，保存后立即生效</span>
                        </p>
                    </div>
                    <el-button type="primary" size="small" icon="el-icon-check" :loading="saving" @click="handleSave">
                        保存配置
                    </el-button>
                </header>

                <div class="cq-course-grid">
                    <article class="cq-course-card is-normal">
                        <div class="cq-course-card__head">
                            <div class="cq-course-card__icon" aria-hidden="true"><i class="el-icon-notebook-2"></i></div>
                            <div>
                                <h3>普通课程</h3>
                                <p>日常课表课堂的点评时间窗</p>
                            </div>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">下课前可评</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.NormalOpenBeforeEndMinutes"
                                        :min="0" :max="180"
                                        controls-position="right"
                                    ></el-input-number>
                                    <span class="cq-unit">分钟</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">距下课还有这么多分钟时，教师即可提交点评</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">允许补评</span>
                                <el-switch
                                    v-model="config.NormalAllowMakeup"
                                    active-text="开"
                                    inactive-text="关"
                                ></el-switch>
                            </div>
                            <p class="cq-tile__tip">错过当堂窗口后，是否允许在期限内补交</p>
                        </div>
                        <div class="cq-tile" :class="{ 'is-disabled': !config.NormalAllowMakeup }">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">补评天数</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.NormalMakeupDays"
                                        :min="1" :max="30"
                                        controls-position="right"
                                        :disabled="!config.NormalAllowMakeup"
                                    ></el-input-number>
                                    <span class="cq-unit">天</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">含上课当天，超过后该课堂不可再评</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">要求预设点评项</span>
                                <el-switch
                                    v-model="config.NormalRequireOfficialItems"
                                    active-text="开"
                                    inactive-text="关"
                                ></el-switch>
                            </div>
                            <p class="cq-tile__tip">关闭后教师只需选等级，仍须完成课堂等级评定</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">未评计入扣分</span>
                                <el-switch
                                    v-model="config.UnreviewedDeductEnabled"
                                    active-text="开"
                                    inactive-text="关"
                                ></el-switch>
                            </div>
                            <p class="cq-tile__tip">开启后，未评普通课按下方分值计入班级扣分汇总</p>
                        </div>
                        <div class="cq-tile" :class="{ 'is-disabled': !config.UnreviewedDeductEnabled }">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">未评扣分</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.UnreviewedDeductScore"
                                        :min="0" :max="100" :precision="2" :step="0.5"
                                        controls-position="right"
                                        :disabled="!config.UnreviewedDeductEnabled"
                                    ></el-input-number>
                                    <span class="cq-unit">分/堂</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">每堂未评普通课计入汇总的扣分</p>
                        </div>
                    </article>

                    <article class="cq-course-card is-special">
                        <div class="cq-course-card__head">
                            <div class="cq-course-card__icon" aria-hidden="true"><i class="el-icon-collection"></i></div>
                            <div>
                                <h3>特殊课程</h3>
                                <p>走班 / 社团等班次课的点评时间窗</p>
                            </div>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">下课前可评</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.SpecialOpenBeforeEndMinutes"
                                        :min="0" :max="180"
                                        controls-position="right"
                                    ></el-input-number>
                                    <span class="cq-unit">分钟</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">距下课还有这么多分钟时，教师即可提交点评</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">允许补评</span>
                                <el-switch
                                    v-model="config.SpecialAllowMakeup"
                                    active-text="开"
                                    inactive-text="关"
                                ></el-switch>
                            </div>
                            <p class="cq-tile__tip">错过当堂窗口后，是否允许在期限内补交</p>
                        </div>
                        <div class="cq-tile" :class="{ 'is-disabled': !config.SpecialAllowMakeup }">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">补评天数</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.SpecialMakeupDays"
                                        :min="1" :max="30"
                                        controls-position="right"
                                        :disabled="!config.SpecialAllowMakeup"
                                    ></el-input-number>
                                    <span class="cq-unit">天</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">含上课当天，超过后该课堂不可再评</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">要求预设点评项</span>
                                <el-switch
                                    v-model="config.SpecialRequireOfficialItems"
                                    active-text="开"
                                    inactive-text="关"
                                ></el-switch>
                            </div>
                            <p class="cq-tile__tip">关闭后教师只需选等级，仍须完成课堂等级评定</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">未评计入扣分</span>
                                <el-switch
                                    v-model="config.SpecialUnreviewedDeductEnabled"
                                    active-text="开"
                                    inactive-text="关"
                                ></el-switch>
                            </div>
                            <p class="cq-tile__tip">开启后，未评特殊课按下方分值计入班级扣分汇总</p>
                        </div>
                        <div class="cq-tile" :class="{ 'is-disabled': !config.SpecialUnreviewedDeductEnabled }">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">未评扣分</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.SpecialUnreviewedDeductScore"
                                        :min="0" :max="100" :precision="2" :step="0.5"
                                        controls-position="right"
                                        :disabled="!config.SpecialUnreviewedDeductEnabled"
                                    ></el-input-number>
                                    <span class="cq-unit">分/堂</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">每堂未评特殊课计入汇总的扣分</p>
                        </div>
                    </article>
                </div>

                <section class="cq-extra">
                    <div class="cq-extra__head cq-extra__head--row">
                        <div>
                            <h3>等级与扣分</h3>
                            <p>自定义等级名称与每节课扣分，提交时快照到点评记录</p>
                        </div>
                        <div class="cq-grade-toolbar">
                            <el-button size="mini" icon="el-icon-plus" @click="addGradeRow">添加</el-button>
                            <el-button size="mini" @click="handleResetGrades">恢复默认</el-button>
                            <el-button type="primary" size="mini" :loading="gradesSaving" @click="handleSaveGrades">保存等级</el-button>
                        </div>
                    </div>
                    <div class="cq-grade-list">
                        <div
                            v-for="(row, index) in grades"
                            :key="'g-' + index + '-' + (row.Id || '0')"
                            class="cq-grade-row"
                            :class="{ 'is-off': !row.IsEnabled }"
                        >
                            <el-input
                                v-model="row.Name"
                                size="small"
                                maxlength="20"
                                placeholder="等级名称"
                                class="cq-grade-row__name"
                            ></el-input>
                            <div class="cq-grade-row__field">
                                <span class="cq-grade-row__label">扣分</span>
                                <el-input-number
                                    v-model="row.DeductScore"
                                    size="small"
                                    :min="0" :max="100" :precision="2" :step="0.5"
                                    controls-position="right"
                                ></el-input-number>
                            </div>
                            <div class="cq-grade-row__field">
                                <span class="cq-grade-row__label">排序</span>
                                <el-input-number
                                    v-model="row.SortOrder"
                                    size="small"
                                    :min="0" :max="999"
                                    controls-position="right"
                                ></el-input-number>
                            </div>
                            <el-switch v-model="row.IsEnabled"></el-switch>
                            <el-button type="text" class="cq-danger" @click="removeGradeRow(index)">删除</el-button>
                        </div>
                        <div v-if="!grades.length" class="cq-grade-empty">暂无等级，点击「添加」或「恢复默认」</div>
                    </div>
                </section>

                <section class="cq-extra">
                    <div class="cq-extra__head">
                        <h3>提交与排行</h3>
                        <p>老师提交时的自定义项，以及班级排行的有效样本门槛</p>
                    </div>
                    <div class="cq-extra__grid">
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">自定义项最高分</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.CustomItemMaxScore"
                                        :min="0.01" :max="1000" :precision="2"
                                        controls-position="right"
                                    ></el-input-number>
                                    <span class="cq-unit">分</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">教师临时添加的点评项，单条不超过此分</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">自定义项数量上限</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.CustomItemMaxCount"
                                        :min="0" :max="20"
                                        controls-position="right"
                                    ></el-input-number>
                                    <span class="cq-unit">条</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">单次提交最多可新增这么多自定义项，0 表示不允许</p>
                        </div>
                        <div class="cq-tile">
                            <div class="cq-tile__row">
                                <span class="cq-tile__label">排行最小课堂数</span>
                                <div class="cq-tile__control">
                                    <el-input-number
                                        v-model="config.RankingMinSample"
                                        :min="1" :max="100"
                                        controls-position="right"
                                    ></el-input-number>
                                    <span class="cq-unit">堂</span>
                                </div>
                            </div>
                            <p class="cq-tile__tip">有效已评课堂少于此数时，班级排行标为样本不足</p>
                        </div>
                    </div>
                </section>

                <div class="cq-banner">
                    <i class="el-icon-info"></i>
                    <span>三级点评项请到「点评项」菜单维护，保存后立即用于新课堂。关闭「要求预设点评项」后可不使用点评项。</span>
                    <button type="button" class="cq-banner__link" @click="goItemConfig">去维护</button>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import {
    getClassroomQualityConfig,
    saveClassroomQualityConfig,
    getClassroomQualityGrades,
    saveClassroomQualityGrades,
    resetClassroomQualityDefaultGrades,
} from '../../api/modules/classroom-quality';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';
import DepartmentPane from '../../components/DepartmentPane';

export default {
    name: 'ClassroomQualityConfig',
    components: { DepartmentPane },
    data() {
        return {
            schoolId: 0,
            schoolName: '',
            loading: false,
            saving: false,
            gradesSaving: false,
            grades: [],
            config: {
                SchoolId: 0,
                NormalOpenBeforeEndMinutes: 10,
                NormalAllowMakeup: true,
                NormalMakeupDays: 1,
                SpecialOpenBeforeEndMinutes: 10,
                SpecialAllowMakeup: true,
                SpecialMakeupDays: 1,
                CustomItemMaxScore: 10,
                CustomItemMaxCount: 5,
                RankingMinSample: 3,
                NormalRequireOfficialItems: true,
                SpecialRequireOfficialItems: true,
                UnreviewedDeductEnabled: true,
                UnreviewedDeductScore: 0.5,
                SpecialUnreviewedDeductEnabled: true,
                SpecialUnreviewedDeductScore: 0.5,
            },
        };
    },
    methods: {
        resolveSchoolId() {
            // 学校 Id 用字符串，避免大整型精度丢失。最后修改：2026-10-18
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return String(fromStore);
            if (this.schoolId) return String(this.schoolId);
            return '';
        },
        treeNodeClick(data) {
            const nextId = data && (data.value != null ? data.value : data.Id);
            const nextKey = nextId != null && nextId !== '' ? String(nextId) : '';
            this.schoolName = (data && (data.label || data.Name)) || '';
            if (!nextKey) return;
            if (String(this.schoolId || '') === nextKey && this.schoolId) return;
            this.schoolId = nextKey;
            this.handleQuery();
        },
        handleQuery() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) return;
            this.loading = true;
            Promise.all([
                getClassroomQualityConfig({ schoolId }),
                getClassroomQualityGrades({ schoolId }),
            ]).then(([cfgRes, gradeRes]) => {
                if (cfgRes && cfgRes.data && cfgRes.data.success) {
                    this.config = Object.assign({}, this.config, cfgRes.data.response);
                } else if (cfgRes && cfgRes.success === false) {
                    // eslint-disable-next-line no-console
                    console.warn('[ClassroomQuality/Config] GetConfig 失败', schoolId, cfgRes.message || cfgRes);
                } else {
                    this.$message.error((cfgRes && cfgRes.data && cfgRes.data.msg) || '加载配置失败');
                }
                if (gradeRes && gradeRes.data && gradeRes.data.success) {
                    this.grades = (gradeRes.data.response || []).map(g => ({
                        Id: g.Id != null ? String(g.Id) : '0',
                        Name: g.Name || '',
                        DeductScore: g.DeductScore != null ? Number(g.DeductScore) : 0,
                        SortOrder: g.SortOrder != null ? Number(g.SortOrder) : 0,
                        IsEnabled: g.IsEnabled !== false,
                    }));
                } else {
                    this.grades = [];
                }
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.warn('[ClassroomQuality/Config] 加载异常', schoolId, err);
            }).finally(() => { this.loading = false; });
        },
        handleSave() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning('请先选择学校');
                return;
            }
            this.saving = true;
            saveClassroomQualityConfig({ ...this.config, SchoolId: schoolId }).then(res => {
                if (res && res.data && res.data.success) this.$message.success(res.data.msg || '保存成功');
                else if (res && res.success === false) {
                    // 全局已 toast
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '保存失败');
                }
            }).finally(() => { this.saving = false; });
        },
        addGradeRow() {
            const nextSort = this.grades.length
                ? Math.max(...this.grades.map(g => Number(g.SortOrder) || 0)) + 1
                : 1;
            this.grades.push({
                Id: '0',
                Name: '',
                DeductScore: 0,
                SortOrder: nextSort,
                IsEnabled: true,
            });
        },
        removeGradeRow(index) {
            this.grades.splice(index, 1);
        },
        handleSaveGrades() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning('请先选择学校');
                return;
            }
            const names = this.grades.map(g => (g.Name || '').trim()).filter(Boolean);
            if (!names.length) {
                this.$message.warning('请至少保留一个等级名称');
                return;
            }
            if (new Set(names).size !== names.length) {
                this.$message.warning('等级名称不能重复');
                return;
            }
            this.gradesSaving = true;
            saveClassroomQualityGrades({
                SchoolId: schoolId,
                Grades: this.grades.map(g => ({
                    Id: g.Id && g.Id !== '0' ? g.Id : 0,
                    SchoolId: schoolId,
                    Name: (g.Name || '').trim(),
                    DeductScore: Number(g.DeductScore) || 0,
                    SortOrder: Number(g.SortOrder) || 0,
                    IsEnabled: g.IsEnabled !== false,
                })),
            }).then(res => {
                if (res && res.data && res.data.success) {
                    this.$message.success(res.data.msg || '等级已保存');
                    getClassroomQualityGrades({ schoolId }).then(gradeRes => {
                        if (gradeRes && gradeRes.data && gradeRes.data.success) {
                            this.grades = (gradeRes.data.response || []).map(g => ({
                                Id: g.Id != null ? String(g.Id) : '0',
                                Name: g.Name || '',
                                DeductScore: g.DeductScore != null ? Number(g.DeductScore) : 0,
                                SortOrder: g.SortOrder != null ? Number(g.SortOrder) : 0,
                                IsEnabled: g.IsEnabled !== false,
                            }));
                        }
                    });
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '保存等级失败');
                }
            }).finally(() => { this.gradesSaving = false; });
        },
        handleResetGrades() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning('请先选择学校');
                return;
            }
            this.$confirm('将删除当前学校全部等级并恢复为优/良/合格/不合格，确认？', '提示', { type: 'warning' })
                .then(() => {
                    resetClassroomQualityDefaultGrades({ schoolId }).then(res => {
                        if (res && res.data && res.data.success) {
                            this.$message.success(res.data.msg || '已恢复默认');
                            this.handleQuery();
                        } else {
                            this.$message.error((res && res.data && res.data.msg) || '恢复失败');
                        }
                    });
                }).catch(() => {});
        },
        goItemConfig() {
            this.$router.push({ path: '/ClassroomQuality/ItemConfig' });
        },
    },
};
</script>

<style scoped>
.cq-config {
    --cq-ink: #0f172a;
    --cq-body: #334155;
    --cq-muted: #64748b;
    --cq-line: #e2e8f0;
    --cq-soft: #f8fafc;
    --cq-normal: var(--btn-primary, #2563eb);
    --cq-special: #0f766e;
    overflow: auto;
    padding: 8px 12px 20px;
}

.cq-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 360px;
    color: var(--cq-muted);
    text-align: center;
    gap: 8px;
}
.cq-empty i {
    font-size: 36px;
    color: var(--cq-normal);
    margin-bottom: 4px;
}
.cq-empty strong {
    font-size: 16px;
    color: var(--cq-ink);
    font-weight: 600;
}
.cq-empty em {
    font-style: normal;
    font-size: 13px;
}

.cq-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: 100%;
}

.cq-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 4px 4px 8px;
}
.cq-head__eyebrow {
    display: block;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    color: var(--cq-normal);
    margin-bottom: 4px;
}
.cq-head__title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: var(--cq-ink);
    letter-spacing: -0.02em;
    line-height: 1.25;
}
.cq-head__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    margin: 8px 0 0;
    font-size: 13px;
    color: var(--cq-muted);
    line-height: 1.45;
}
.cq-school-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    background: var(--btn-primary-plain-bg, #eff6ff);
    color: var(--cq-normal);
    font-weight: 600;
    font-size: 12px;
}

.cq-course-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.cq-course-card {
    background: #fff;
    border: 1px solid var(--cq-line);
    border-radius: 12px;
    padding: 16px 16px 12px;
    box-shadow: 0 1px 0 rgba(15, 23, 42, 0.03);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.cq-course-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}
.cq-course-card.is-normal {
    border-top: 3px solid var(--cq-normal);
}
.cq-course-card.is-special {
    border-top: 3px solid var(--cq-special);
}

.cq-course-card__head {
    display: grid;
    grid-template-columns: 40px minmax(0, 1fr);
    gap: 10px;
    align-items: center;
    margin-bottom: 12px;
}
.cq-course-card__head h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--cq-ink);
}
.cq-course-card__head p {
    margin: 2px 0 0;
    font-size: 12px;
    color: var(--cq-muted);
    line-height: 1.4;
}
.cq-course-card__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}
.is-normal .cq-course-card__icon {
    background: var(--btn-primary-plain-bg, #eff6ff);
    color: var(--cq-normal);
}
.is-special .cq-course-card__icon {
    background: #f0fdfa;
    color: var(--cq-special);
}

.cq-status {
    font-size: 12px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 999px;
    white-space: nowrap;
}
.cq-status.is-on {
    background: var(--btn-success-plain-bg, #ecfdf5);
    color: var(--btn-success, #059669);
}
.cq-status.is-off {
    background: #f1f5f9;
    color: #64748b;
}

.cq-tile {
    padding: 10px 0;
    border-top: 1px dashed #e8edf5;
    transition: opacity 0.2s ease;
}
.cq-tile.is-disabled {
    opacity: 0.55;
}
.cq-tile__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.cq-tile__label {
    font-size: 13px;
    font-weight: 600;
    color: var(--cq-body);
}
.cq-tile__control {
    display: flex;
    align-items: center;
    gap: 8px;
}
.cq-tile__tip {
    margin: 6px 0 0;
    font-size: 12px;
    color: var(--cq-muted);
    line-height: 1.45;
}
.cq-unit {
    font-size: 12px;
    color: var(--cq-muted);
    min-width: 1.5em;
}

.cq-extra {
    background: #fff;
    border: 1px solid var(--cq-line);
    border-radius: 12px;
    padding: 16px;
}
.cq-extra__head {
    margin-bottom: 12px;
}
.cq-extra__head h3 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--cq-ink);
}
.cq-extra__head p {
    margin: 4px 0 0;
    font-size: 12px;
    color: var(--cq-muted);
}
.cq-extra__head--row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}
.cq-extra__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}
.cq-extra .cq-tile {
    border: 1px solid #e8edf5;
    border-radius: 10px;
    background: var(--cq-soft);
    padding: 12px;
}
.cq-grade-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    flex-shrink: 0;
}
.cq-grade-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.cq-grade-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 14px;
    padding: 10px 12px;
    border: 1px solid #e8edf5;
    border-radius: 10px;
    background: var(--cq-soft);
}
.cq-grade-row.is-off {
    opacity: 0.55;
}
.cq-grade-row__name {
    width: 140px;
    max-width: 100%;
}
.cq-grade-row__field {
    display: flex;
    align-items: center;
    gap: 6px;
}
.cq-grade-row__label {
    font-size: 12px;
    color: var(--cq-muted);
    white-space: nowrap;
}
.cq-grade-row ::v-deep .el-input-number {
    width: 120px;
}
.cq-grade-row ::v-deep .el-input-number .el-input__inner {
    height: 32px;
    line-height: 32px;
    padding-left: 8px;
    padding-right: 36px;
    text-align: left;
}
.cq-grade-empty {
    padding: 28px 12px;
    text-align: center;
    color: var(--cq-muted);
    font-size: 13px;
    border: 1px dashed #e2e8f0;
    border-radius: 10px;
    background: var(--cq-soft);
}
.cq-danger {
    color: #f56c6c;
}

.cq-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 10px;
    background: var(--btn-primary-plain-bg, #eff6ff);
    border: 1px solid var(--btn-primary-plain-border, #bfdbfe);
    color: var(--cq-body);
    font-size: 13px;
    line-height: 1.45;
}
.cq-banner i {
    color: var(--cq-normal);
    font-size: 16px;
}
.cq-banner span {
    flex: 1;
}
.cq-banner__link {
    border: 0;
    background: transparent;
    color: var(--cq-normal);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    white-space: nowrap;
    transition: color 0.15s ease;
}
.cq-banner__link:hover {
    color: var(--btn-primary-hover, #1d4ed8);
}

.cq-config ::v-deep .el-input-number {
    width: 128px;
}
.cq-config ::v-deep .el-switch__label {
    font-size: 12px;
    color: var(--cq-muted);
}
.cq-config ::v-deep .el-switch__label.is-active {
    color: var(--cq-body);
}

@media (prefers-reduced-motion: reduce) {
    .cq-course-card,
    .cq-tile,
    .cq-banner__link {
        transition: none;
    }
}

@media (max-width: 1100px) {
    .cq-course-grid,
    .cq-extra__grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .cq-head {
        flex-direction: column;
        align-items: stretch;
    }
    .cq-head__title {
        font-size: 20px;
    }
    .cq-tile__row {
        flex-wrap: wrap;
    }
}
</style>
